// extracted by mini-css-extract-plugin
export default {"container":"CreateTruck_container__RTkks","buttongroup":"CreateTruck_buttongroup__KS6hT"};